module.exports = __webpack_public_path__ + "static/media/heb.8af4f0f0.jpg";